import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { isNil } from 'lodash';
import { toaster } from 'Helpers/index';

import { AuthActionStatusAtom, authActionStatusAtom, authErrorAtom } from 'Recoil/auth.atom';
import { authForgetPassword } from 'Services/auth.services';

import ForgetPasswordForm from 'Components/auth/forget-password-form';

import './forget-password.scss';
import { useRecaptchaV3 } from 'Hooks/index';

const ForgetPasswordPage = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const [status, setStatus] = useRecoilState<AuthActionStatusAtom>(authActionStatusAtom);
  const [error, setError] = useRecoilState<any>(authErrorAtom);
  const executeRecaptcha = useRecaptchaV3(); 

  const handleSubmit = async ({ email }) => {
    setStatus({ ...status, forgetPassword: 'loading' });
    const recaptchaToken = await executeRecaptcha("forgot_password");
    const responseData = await authForgetPassword({ email, recaptchaToken });

    if (!isNil(responseData.error)) {
      setStatus({ ...status,  forgetPassword: 'error' });
      setError(responseData?.error);
    }
    else {
      setStatus({ ...status,  forgetPassword: 'success' });
    }
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>{t('pageTitle.forgetPassword')}</title>
      </Helmet>

      <div className="forget-password-page">
        <div className="forget-password-page--header">

        </div>
        <img
          alt={t('alt.logo')}
          src="/assets/images/logo_white.png"
          style={{
            height: '50px', width: "100%", maxWidth: "300px",
            margin: "60px auto 0"
          }}
        />
        <div className="forget-password-page--main">
          <div className="forget-password-page--container">
            <div className="forget-password-page--form">
              <div className="forget-password-page--form-title">
                <h4>{t('title.resetPassword')}</h4>
              </div>

              <ForgetPasswordForm
                status={status.forgetPassword}
                onSubmit={handleSubmit}
              />

            </div>
            <div className="forget-password-page--bot"></div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ForgetPasswordPage;
